// This icon file is generated automatically.
var PDownloadOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M5.9 8.33c.05.06.15.06.2 0L7.85 6.1c.06-.08 0-.2-.1-.2H6.59V.62A.13.13 0 006.47.5h-.94a.13.13 0 00-.13.13V5.9H4.25c-.1 0-.16.12-.1.2L5.9 8.33zm5.82-.55h-.94a.13.13 0 00-.12.13v2.4H1.34v-2.4a.13.13 0 00-.12-.13H.28a.13.13 0 00-.12.13V11c0 .28.22.5.5.5h10.68a.5.5 0 00.5-.5V7.9a.13.13 0 00-.12-.12z", "fill-rule": "nonzero" } }] }, "name": "p-download", "theme": "outlined" };
export default PDownloadOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PDownloadOutlined.js
// module id = 3351
// module chunks = 0